import React from 'react';
import { Query } from 'react-apollo';
import { redirectToHome, redirectToLoginWithRedirectAfter } from 'helpers/redirects';
import { Container, Loader } from 'semantic-ui-react';
import viewerQuery from './inject-user.gql';

export default App => {
  function serializeUser({ viewer }) {
    return {
      id: viewer.id,
      slug: viewer.slug,
      name: viewer.name,
      first_name: viewer.firstName,
      last_name: viewer.lastName,
      email: viewer.email,
      locale: viewer.locale,
      countryName: viewer.countryName,
      confirmed: viewer.confirmed,
      image_url_50: viewer.smallAvatarUrl,
      role: viewer.role.charAt(0) + viewer.role.slice(1).toLowerCase(),
      is_admin: viewer.admin,
      is_host: viewer.host,
      memberships: viewer.memberships.nodes,
      isBusinessSeller: viewer.isBusinessSeller,
      businessAddress: viewer.businessAddress,
      businessEmail: viewer.businessEmail,
      businessPhoneNumber: viewer.businessPhoneNumber,
      venueTagging: viewer.venueTagging,
      waitlistFanOptIn: viewer.waitlistFanOptIn,
      privacyPolicyUrl: viewer.privacyPolicyUrl
    };
  }

  return (
    <Query query={viewerQuery}>
      {({ loading, error, data }) => {
        if (loading)
          return (
            <Container>
              <Loader active />
            </Container>
          );
        if (error) return redirectToHome();

        if (data && data.viewer.id) return <App user={serializeUser(data)} />;
        redirectToLoginWithRedirectAfter(window.location.pathname);
        return null;
      }}
    </Query>
  );
};
